import { Button } from "@kaltura/ds-react-components";
import { Delete24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { BulkActionProps } from "@kaltura/mediaspace-shared-selectable-media-list";
import { useBulkDelete } from "./useBulkDelete";
import { BulkDeleteConfirmationModal } from "./BulkDeleteConfirmationModal";

interface BulkDeleteProps extends BulkActionProps {
    entryIds: string[];
    apiUrl: string;
}

/**
 * Component for bulk permanently deleting entries from the recycle bin
 * @data-endpoint recyclebin-recycle-bin-ds-delete
 */
export const BulkDelete = ({ entryIds, reloadMedia, apiUrl }: BulkDeleteProps) => {
    const { selectedCount, openConfirmation, processing, handleClick, handleDelete, closeConfirmation } = useBulkDelete(
        { entryIds, reloadMedia, apiUrl }
    );

    return (
        <>
            <Button
                variant="borderless"
                color="secondary"
                onClick={handleClick}
                disabled={entryIds.length === 0}
                startIcon={<Delete24Icon />}
            >
                {translate("Delete")}
            </Button>

            <BulkDeleteConfirmationModal
                open={openConfirmation}
                processing={processing}
                selectedCount={selectedCount}
                onClose={closeConfirmation}
                onConfirm={handleDelete}
            />
        </>
    );
};

export default BulkDelete;
